import { IsOptional, IsString, IsInt, IsDate, IsNumber } from 'class-validator';

export class AisTransactionRequestDto {
  @IsInt()
  businessEntityId: number;

  @IsInt()
  businessEntityBankId?: number;

  @IsString()
  @IsOptional()
  providerCode?: string;

  @IsString()
  @IsOptional()
  account?: string;

  @IsDate()
  @IsOptional()
  fromDate?: string;

  @IsDate()
  @IsOptional()
  toDate?: string;

  @IsNumber()
  @IsOptional()
  currentBalance?: number;
}
